export default __webpack_public_path__ + "static/media/logo5.1530428a.png";